import type { PatientObject } from "@astrana/ui/modules";

import type { MemberByIdResult } from "./graphql/memberById";

// Mapping mirrors pathways-cm-frontend's Member360 construction
// (Member360.tsx patient prop). The MemberProfile modules forward these
// values to EZCap-backed resolvers, so wrong values produce
// "EZCap API Error (400)". Key gotchas:
//   - memberId must be the memberPolicyId, not the raw memberId field
//   - mkey must be memberIdOthers.apolloMemberKey, not memberPolicyId
//   - mpi must be memberIdOthers.mbi, not memberIdOthers.mpi
//   - companyId must be undefined when ipaCode is the sentinel "NA"
//   - astranaId must be forwarded: the Claims module's useMedicalClaims skips
//     its connectPatient query unless patient.astranaId is set, so without it
//     the Claims tab renders empty (AC-CLM-1 / ACT-1249).
export function toPatientObject(
  member: NonNullable<MemberByIdResult["PathwaysMember"]>,
): PatientObject {
  return {
    memberId: member.memberPolicyId,
    mkey: member.memberIdOthers?.apolloMemberKey,
    companyId: member.ipaCode === "NA" ? undefined : member.ipaCode,
    mpi: member.memberIdOthers?.mbi,
    astranaId: member.astranaId,
    memberObjectId: member._id,
    sourceId: member.sourceId ?? "",
  };
}
